import React, { useState, useEffect } from 'react';
import { Mail, Download, Trash2, CheckCircle, Loader2, Search } from 'lucide-react';
import api from '../../utils/api';

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [page, setPage]       = useState(1);

  const fetch = async () => {
    setLoading(true);
    try { const r = await api.get(`/newsletter/admin/all?page=${page}&limit=20${search?`&search=${search}`:''}`); setItems(r.data.items||[]); setTotal(r.data.total||0); }
    catch(e){console.error(e);} finally{setLoading(false);}
  };
  useEffect(()=>{fetch();},[page,search]);

  const del = async (id) => { if(!window.confirm('Remove subscriber?')) return; await api.delete(`/newsletter/${id}`); fetch(); };
  const exportCSV = () => {
    const csv = ['Email,Name,Status,Date',...items.map(i=>`${i.email},${i.name||''},${i.isActive?'Active':'Unsubscribed'},${new Date(i.createdAt).toLocaleDateString()}`)].join('\n');
    const b = new Blob([csv],{type:'text/csv'}); const u=URL.createObjectURL(b); const a=document.createElement('a'); a.href=u; a.download='subscribers.csv'; a.click(); URL.revokeObjectURL(u);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold text-gray-900 flex items-center gap-2"><Mail size={22} className="text-royal-800"/>Newsletter</h1>
          <p className="text-gray-500 text-sm mt-0.5">{total} subscribers</p>
        </div>
        <button onClick={exportCSV} className="btn-royal text-sm py-2.5 px-5 flex items-center gap-2"><Download size={15}/>Export CSV</button>
      </div>
      <div className="bg-white rounded-2xl shadow-card border border-gray-100 overflow-hidden">
        <div className="flex items-center gap-3 px-5 py-3.5 border-b border-gray-100">
          <div className="relative flex-1 max-w-xs"><Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"/><input className="w-full pl-9 pr-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-royal-800/20" placeholder="Search subscribers..." value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/></div>
        </div>
        {loading ? <div className="flex items-center justify-center h-48 gap-2 text-gray-400"><Loader2 size={20} className="animate-spin"/>Loading...</div> : (
          <table className="w-full text-sm">
            <thead><tr className="border-b border-gray-100">{['Email','Name','Status','Subscribed',''].map(h=><th key={h} className="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide px-5 py-3">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-gray-50">
              {items.map(item=>(
                <tr key={item._id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-5 py-3 font-medium text-gray-800">{item.email}</td>
                  <td className="px-5 py-3 text-gray-600">{item.name||'—'}</td>
                  <td className="px-5 py-3"><span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${item.isActive?'bg-emerald-100 text-emerald-700':'bg-gray-100 text-gray-500'}`}><CheckCircle size={11}/>{item.isActive?'Active':'Unsubscribed'}</span></td>
                  <td className="px-5 py-3 text-gray-400 text-xs">{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td className="px-5 py-3"><button onClick={()=>del(item._id)} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"><Trash2 size={14}/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
